// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".p-Vaw{padding:0 8px}@media screen and (min-width:400px){.p-Vaw{padding:0 16px}}@media screen and (min-width:768px){.p-Vaw{padding:0}}.j63qU{display:flex;flex-flow:wrap;align-items:center;justify-content:space-between;margin:24px 0;grid-gap:8px;gap:8px}.bZuyU{margin:0;color:#2d2d2d;font-family:\"Merriweather\",serif;font-size:26px;font-weight:700;line-height:30px}@media screen and (min-width:768px){.bZuyU{font-size:36px;line-height:44px}}.Ku2Ca .WRtsF{padding:0}._6kq7E{display:flex;flex-direction:column}.kNHaW+.kNHaW{margin-top:8px}@media screen and (min-width:768px){.kNHaW+.kNHaW{margin-top:32px}}.V2u6Y{display:flex;align-items:center;padding:0 8px;margin-bottom:16px;color:#2d2d2d;font-size:22px;font-weight:700;line-height:32px}@media screen and (min-width:768px){.V2u6Y{padding:0}}.iLsDD{display:inline-flex;width:24px;height:24px;align-items:center;justify-content:center;margin-left:8px;background-color:#f4e600;border-radius:50%;opacity:0;transition:opacity .3s}.iLsDD svg{transform:rotate(-90deg)}.V2u6Y:hover .iLsDD{opacity:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": "p-Vaw",
	"header": "j63qU",
	"title": "bZuyU",
	"page": "Ku2Ca",
	"grid": "WRtsF",
	"sections": "_6kq7E",
	"section": "kNHaW",
	"sectionLink": "V2u6Y",
	"sectionIcon": "iLsDD"
};
module.exports = ___CSS_LOADER_EXPORT___;
